module.exports = __webpack_public_path__ + "media/images/seta-ordenar-0fbafa456ebb54e8388327f90eb40bfa.svg";